<template>
        <header class="main-header" :class="{ 'scrolled': isScrolled }">
      <div class="header-container">
        <div class="logo">
          <router-link to="/">
            <h1>AI算力之门</h1>
            <span>A Gateway of FLOPs</span>
          </router-link>
        </div>
        <nav class="header-nav">
          <router-link to="/" class="nav-item active">首页</router-link>
          <router-link to="/products" class="nav-item">产品</router-link>
          <router-link to="/solutions" class="nav-item">解决方案</router-link>
          <!-- <router-link to="/model" class="nav-item">模型</router-link> -->
          <router-link to="/pricing" class="nav-item">定价</router-link>
              <!-- 客服 -->
          <div class="kefu-box"  @mouseenter="showChatImg" @mouseleave="hideChatImg">
            <i class="far fa-comments kefu" ></i>
            <div class="chat-img-box" id="chat-img"  hidden>
              <span>算力之门客户交流群</span>
                <img  src="@/assets/wechat.png"  alt="logo" class="chat-img" height="200" width="200" />
              <span>微信扫码加入</span>
              </div>
          </div>
         
          <!-- <router-link to="/docs" class="nav-item">文档</router-link> -->
          <!-- <a href="/login" class="nav-item login-btn">控制台</a> -->
        </nav>
      </div>

    </header>
</template>
<script>
export default {
    name: 'Headers-node',
    data() {
        return {
            isScrolled: false
        }
    },
    methods: {
        handleScroll() {
            this.isScrolled = window.scrollY > 10
        },
        showChatImg() {
            document.getElementById('chat-img').hidden = false
        },
        hideChatImg() {
            document.getElementById('chat-img').hidden = true
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>
<style lang="scss" scoped>

// 头部导航
.main-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0);
  // backdrop-filter: blur(10px);
  z-index: 1000;
  // border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  &.scrolled {
    background: rgba(0, 0, 0, 0.95);
    backdrop-filter: blur(10px);
  }

  .header-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 70px;
  }

  .logo {
    h1 {
      margin: 0;
      font-size: 24px;
      font-weight: 700;
      background: linear-gradient(135deg, #fff, #fff);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      transition: all 0.3s ease;
    }
    span {
      font-size: 12px;
      color: #fff;
      display: block;
      margin-top: -2px;
      transition: all 0.3s ease;
    }
  }



  &.scrolled .header-nav .nav-item {
    color: #fff;
    
    &:hover {
      color: #ff3466;
    }
  }

  .header-nav {
    display: flex;
    align-items: center;
    gap: 32px;

    .nav-item {
      color: #fff;
      text-decoration: none;
      font-weight: 500;
      padding: 8px 16px;
      border-radius: 6px;
      transition: all 0.3s ease;

      &:hover {
        color: #ff3466;
      }
    }
  }
}

.kefu{
  font-size: 14px;
  color: #fff;
  background-color: #fff0;
  cursor: pointer;
  text-align: center;
}
.kefu-box{
  position: relative;
  cursor: pointer;
  height: 100%;
  &:hover{
    .kefu{
      color: #ff3466; 
    }
  }
}
.chat-img-box{
  width: 220px;
  height: fit-content;
  padding: 20px 10px;
  position: absolute;
  left: -100px;
  top: 50px;
  border-radius: 20px;
  box-shadow: 0 0 10px 0px rgba(0,0,0,0.5);
  background-color: #1a2a54;
  img{
    display: block;
    margin: auto;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  span{
    display: block;
    width: fit-content;
    margin: auto;
    font-size: 12px;
  }
}

</style>